// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function MyClientsWidgetRowLayout(props) {
  let __dim = props.dim;
  let matches = props.matches;
  let status = props.status;
  let dim = __dim !== undefined ? __dim : false;
  return JsxRuntime.jsxs("li", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.name,
        className: "min-w-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              status,
              matches
            ],
            className: "hidden md:flex flex-col items-end gap-y-1 text-right"
          }),
          props.menu
        ],
        className: "flex shrink-0 items-start md:gap-x-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          status,
          matches
        ],
        className: "col-span-2 flex items-center gap-x-3 pt-2 md:hidden"
      })
    ],
    className: TailwindMerge.twMerge([
      "relative grid grid-cols-[1fr_auto] gap-x-4 gap-y-2 py-4",
      dim ? "opacity-60" : ""
    ])
  });
}

let make = MyClientsWidgetRowLayout;

exports.make = make;
/* tailwind-merge Not a pure module */
